import { render } from "./TemplateList.vue?vue&type=template&id=4cde4f28"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"

import "./TemplateList.vue?vue&type=style&index=0&id=4cde4f28&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__